import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const HomeBanner = () => {
  const { t } = useLanguage();

  return (
    <section className="cf-hero">
      <div className="container position-relative" style={{zIndex:1}}>
        <div className="row align-items-center g-5">

          {/* ── Left: Text ── */}
          <div className="col-lg-6">
            <span className="eyebrow-badge anim-fade anim-delay-1">
              <i className="bi bi-flower1"></i>
              {t('home.heroEyebrow')}
            </span>

            <h1 className="hero-title mb-2 anim-fade-up anim-delay-2">
              {t('home.heroTitle')}
              <br />
              <em>{t('home.heroTitleEm')}</em>
            </h1>

            <p className="hero-subtitle mb-3 anim-fade-up anim-delay-3">
              {t('home.heroSubtitle')}
            </p>

            <p className="hero-desc mb-4 anim-fade-up anim-delay-4">
              {t('home.heroDesc')}
            </p>

            {/* CTA Buttons */}
            <div className="d-flex flex-wrap gap-3 mb-4 anim-fade-up anim-delay-5">
              <Link to="/who-is-chaitralee" className="btn-brand">
                {t('home.ctaLearnMore')}
                <i className="bi bi-arrow-right"></i>
              </Link>
              <Link to="/you-can" className="btn-brand-outline">
                {t('home.ctaJoin')}
                <i className="bi bi-heart"></i>
              </Link>
            </div>

            {/* Dates badge */}
            <div className="hero-dates-badge anim-fade anim-delay-6">
              <div className="text-center">
                <div className="hero-date-label">{t('home.heroBorn')}</div>
                <div className="hero-date-desc">{t('home.heroBornLabel')}</div>
              </div>
              <div className="hero-divider-v"></div>
              <div className="text-center">
                <div className="hero-date-label" style={{color:'rgba(253,246,236,0.65)'}}>{t('home.heroPassed')}</div>
                <div className="hero-date-desc">{t('home.heroPassedLabel')}</div>
              </div>
            </div>
          </div>

          {/* ── Right: Creative Image Collage ── */}
          <div className="col-lg-6 anim-fade anim-delay-3">
            <div className="hero-collage">
              <div className="hero-collage-grid">

                {/* Main large portrait */}
                <div className="hero-col-main">
                  <div className="placeholder-img-main">
                    <i className="bi bi-person-bounding-box mb-3" style={{fontSize:'3.5rem',color:'rgba(255,255,255,0.18)'}}></i>
                    <span style={{fontSize:'0.7rem',color:'rgba(255,255,255,0.22)',fontFamily:'Hind,sans-serif',letterSpacing:'0.04em'}}>
                      public/assets/images/home/portrait-main.jpg
                    </span>
                  </div>
                  <div className="hero-col-caption">
                    <div className="hero-caption-quote">"Rose Colour Glasses"</div>
                    <div className="hero-caption-sub">Her philosophy. Her legacy.</div>
                  </div>
                </div>

                {/* Top right small */}
                <div className="hero-col-sm">
                  <div className="placeholder-img-sm">
                    <i className="bi bi-image"></i>
                  </div>
                </div>

                {/* Bottom right small with badge */}
                <div className="hero-col-sm2">
                  <div className="placeholder-img-sm2">
                    <i className="bi bi-image"></i>
                  </div>
                  <div className="hero-float-badge">
                    <i className="bi bi-star-fill mb-1" style={{fontSize:'0.8rem'}}></i>
                    She Is...
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HomeBanner;
